import type { CheckoutOptions } from '@tebexio/tebex.js'

// below this size tebex.js opens the checkout and the portal in a new window instead of its lightbox (same breakpoint as
// tebex.js). our cross-origin-opener-policy cuts that window off from the page (webkit even with
// 'same-origin-allow-popups'), so the launch failed and the checkout opened twice: in the dead window and the fallback
export const isSmallScreen = () => window.matchMedia('(max-width: 800px), (max-height: 760px)').matches

// the page behind the tebex.js lightbox must not scroll, the gutter keeps the space of the scrollbar so nothing shifts
export const lockScroll = (locked: boolean) => {
  const style = document.documentElement.style
  style.overflow = locked ? 'hidden' : ''
  style.scrollbarGutter = locked ? 'stable' : ''
}

// tebex expects 'de_DE' instead of 'de-DE'
export const tebexLocale = (language?: string) => language?.replace('-', '_')

// shared by the checkout and the portal, in the colors of our dark theme (see tailwind.config.ts)
export const appearance: Pick<CheckoutOptions, 'theme' | 'colors' | 'closeOnEsc' | 'popupOnMobile'> = {
  theme: 'dark',
  colors: {
    'primary': '#24BE62',
    // the order summary uses both background and surface-variant, the payment form uses surface
    'background': '#161616',
    'surface-variant': '#161616',
    'surface': '#000000',
    'fields': '#303030',
    'field-border': '#303030',
    'success': '#24BE62',
    'green': '#24BE62',
    'warning': '#be8d24',
    'error': '#de2d3a',
    'red': '#de2d3a',
  },
  closeOnEsc: true,
  // tebex.js calls the lightbox "popup", so this keeps the lightbox if its own size check disagrees with ours
  popupOnMobile: true,
}
